/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { forkJoin, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as getUploadedGamesAction from 'app/library/store/actions/get-library-uploaded-games.action';
import { AssetsService, UserEventsService } from 'app/shared/services/';

@Injectable()
export class GetLibraryUploadedGamesEffects {
  getUploads$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getUploadedGamesAction.GET_LIBRARY_UPLOADED_GAMES),
      switchMap((action: getUploadedGamesAction.GetLibraryUploadedGames) => {
        const events = action.payload.events;
        const eventRequests = events.map((event) => this.userEventsService.getById(event.id));
        if (events && !events.length) {
          return of(new getUploadedGamesAction.GetLibraryUploadedGamesSuccess([]));
        }
        return forkJoin(eventRequests).pipe(
          map((eventsResponses) => {
            const userEventGames = eventsResponses.reduce((acc: any[], userEvent: any) => {
              if (userEvent.assets && userEvent.assets.length) {
                userEvent.assets = userEvent.assets.map((ua) => {
                  return {
                    ...ua,
                    urlThumb: ua.urlThumb || this.assetsService.getUrlThumb(ua.url, ua.is60fps),
                    event: {
                      ...userEvent,
                      assets: null,
                    },
                  };
                });
                acc = [...acc, ...userEvent.assets];
              }
              return acc;
            }, []);
            return new getUploadedGamesAction.GetLibraryUploadedGamesSuccess(userEventGames);
          }),
          catchError((error) => of(new getUploadedGamesAction.GetLibraryUploadedGamesFail(error.message)))
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private userEventsService: UserEventsService,
    private assetsService: AssetsService
  ) {}
}
